/**
 * Full Image Carousel Section
 * Interactive image carousel with Splide.js fade transitions
 */

window.initFullImageCarousel = function(sectionId, slideInterval, hasMultipleSlides) {
  const sectionContainer = document.getElementById('shopify-section-' + sectionId);
  if (!sectionContainer) return;

  const splideElementId = 'splide-' + sectionId;
  const splideElement = sectionContainer.querySelector('#' + splideElementId);
  if (!splideElement) return;

  // Avoid double-init (theme editor section reloads, deferred script races).
  if (splideElement.splide) {
    try {
      splideElement.splide.destroy(true);
    } catch (error) {
      // Ignore destroy errors from stale instances.
    }
  }

  const progressBar = sectionContainer.querySelector('[data-progress-bar]');
  const slideItems = sectionContainer.querySelectorAll('.full-image-carousel__slide-item');

  let splideInstance = null;

  /** @type {number | null} */
  let progressFrame = null;

  function updateProgressBar() {
    if (!progressBar || !hasMultipleSlides || !splideInstance) return;
    if (progressFrame !== null) return;

    progressFrame = requestAnimationFrame(function() {
      progressFrame = null;
      if (!progressBar || !splideInstance) return;

      const end = splideInstance.Components.Controller.getEnd() + 1;
      const rate = Math.min((splideInstance.index + 1) / end, 1);
      progressBar.style.width = `${String(100 * rate)}%`;
    });
  }

  function updateSlideContent(index) {
    slideItems.forEach((item, i) => {
      item.classList.toggle('is-active', i === index);
    });
  }

  function initSplide() {
    if (typeof Splide === 'undefined') {
      if (window.__splideReady) {
        window.__splideReady.then(function() {
          initSplide();
        });
      }
      return;
    }

    const config = {
      type: 'fade',
      rewind: true,
      autoplay: hasMultipleSlides,
      interval: slideInterval * 1000,
      arrows: false,
      pagination: false,
      pauseOnHover: false,
      pauseOnFocus: true,
      speed: 500,
      easing: 'ease',
      updateOnMove: true,
      drag: hasMultipleSlides,
    };

    splideInstance = new Splide(splideElement, config);

    splideInstance.on('mounted', function() {
      updateSlideContent(splideInstance.index);
      updateProgressBar();
    });

    splideInstance.on('move', function(newIndex) {
      updateSlideContent(newIndex);
    });

    splideInstance.on('moved', function() {
      updateProgressBar();
    });

    splideInstance.mount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSplide);
  } else {
    initSplide();
  }
};
